import setCurrentPage from "src/Utils/setCurrentPage";

export const DATA_GEN_AI_DEMO_ISNA_END = {
  title:
    "Find out more about Infosys \n Smart Network Assurance from\n our staff.",
  bgImage: "ENG/ISNA/ISNA_GEN_AI_Demo_01.jpg",
  optionsButtons: [
    {
      label: "Overview",
      onClick: () => setCurrentPage("ENG_201"),
      type: "transparent",
      startIcon: "arrow-left",
    },
    {
      label: "RESTART DEMO",
      onClick: () => setCurrentPage("ENG_206"),
      endIcon: "arrow-right",
    },
  ],
};
